
        Component.define('template-header', (el, params) => {
            /**
 * Cada componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el                     = $(el);
const $btnSearch              = $el.find('.search');
const $btnDownloadCenter      = $el.find('.download-center');
const $btnMobile              = $el.find('.box-menu-mobile');
const $hamburger              = $el.find('.menu-mobile');
const $menu                   = $el.find('.menu');

$btnSearch.on('click', function(){
    $('.wrapper-modal').addClass('open');

    //$('[data-component="modal-search"] input').focus();
});

$btnDownloadCenter.on('click', function(){
    $('.wrapper-modal-download').addClass('open');
    $body.addClass('modal-opened');

    $('[data-component="modal-download-center"]').trigger('modal-download-center:open');
});

const open = () => {
    $hamburger.toggleClass('is-active');
    $menu.slideToggle();
    $el.toggleClass('menu-open');
};

const close = () => {
    $hamburger.removeClass('is-active');
    $menu.slideUp();
    $el.removeClass('menu-open');
};

$btnMobile.on('click', function(){
    open();
});

$body.on('click', function (e) {
    if ($hamburger.is('.is-active') && !$(e.target).closest('[data-component="template-header"]').length) {
        close();
    }
});

$window
    .on('resize', function() {
        if (wW > 767) {
            $el.removeClass('menu-open');
            $hamburger.removeClass('is-active');
            $menu.attr('style', '');
        }
    });

        });